import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="error-boundary">
        <div className="text-center max-w-sm">
          <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-4">
            <AlertTriangle size={24} className="text-red-500" />
          </div>
          <h2 className="text-lg font-extrabold text-torre-slate mb-1">Algo salió mal</h2>
          <p className="text-sm text-slate-500 mb-4">Ha ocurrido un error inesperado. Intenta recargar la página.</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-torre-teal text-white text-sm font-bold hover:bg-torre-teal-hover transition-colors"
            data-testid="error-boundary-reload"
          >
            <RefreshCw size={14} /> Recargar
          </button>
        </div>
      </div>
    );
  }
}
